import { css } from 'styled-components';

const styles = css`
  border-radius: ${(props) =>
    props.isMobileWebTileEnhancementEnabled ? '0px' : props.theme.spacing.ELEM_SPACING.XS_1};
  background: ${(props) => props.theme.colorPalette.white};
  margin-top: ${(props) =>
    props.fromATBDrawer
      ? props.theme.spacing.ELEM_SPACING.MED_1
      : props.theme.spacing.ELEM_SPACING.MED};
  ${(props) => !props.fromATBDrawer && ` box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.06)`};
  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.MED_2};
    margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.XS_6};
  }
  ${(props) => props.fromATBDrawer && ` margin-bottom: ${props.theme.spacing.ELEM_SPACING.MED_2}`};
  .free-shipping-progress-bar-wrapper {
    padding: ${(props) =>
      !props.fromATBDrawer
        ? `20px ${props.theme.spacing.ELEM_SPACING.MED_1}`
        : `${props.theme.spacing.ELEM_SPACING.MED_1} ${props.theme.spacing.ELEM_SPACING.XS_1}`};

    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      padding: ${(props) =>
        !props.fromATBDrawer
          ? props.theme.spacing.ELEM_SPACING.MED_1
          : `${props.theme.spacing.ELEM_SPACING.MED_1} ${props.theme.spacing.ELEM_SPACING.SM}`};
    }
    ${(props) =>
      props.fromATBDrawer &&
      `border-radius: 10px;
    border: 1px solid #D8D8D8;`}
  }
  .header-free-shipping {
    letter-spacing: 0.5px;
  }
  .text-style-1 {
    color: ${(props) => props.theme.colors.TEXT.ORANGE};
    text-transform: uppercase;
  }
  .text-style-2 {
    color: ${(props) => props.theme.colors.TEXT.LIGHTBLUE};
    text-transform: uppercase;
  }
  .text-style-3 {
    color: ${(props) => props.theme.colors.TEXT.DARKPINK};
    text-transform: uppercase;
  }
  .text-style-4 {
    color: ${(props) => props.theme.colors.TEXT.DARKERGRAY};
    text-transform: capitalize;
  }
  .free-shipping-progress-bar-header {
    display: flex;
    align-items: center;
    padding-bottom: ${(props) =>
      props.fromATBDrawer
        ? props.theme.spacing.ELEM_SPACING.REG
        : props.theme.spacing.ELEM_SPACING.MED};
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      padding-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.REG};
    }
  }
  .free-shipping-progress-bar-text-wrapper {
    font-size: ${(props) =>
      !props.fromATBDrawer
        ? props.theme.typography.fontSizes.fs14
        : props.theme.typography.fontSizes.fs11};
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      font-size: ${(props) => props.theme.typography.fontSizes.fs12};
    }
  }
  .free-ship-anchor {
    font-size: ${(props) =>
      !props.fromATBDrawer
        ? props.theme.typography.fontSizes.fs12
        : props.theme.typography.fontSizes.fs10};
    padding-left: ${(props) => props.theme.spacing.ELEM_SPACING.XXXS};
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      font-size: ${(props) => props.theme.typography.fontSizes.fs12};
    }
  }
  .free-shipping-text {
    color: ${(props) => props.theme.colorPalette.green[500]};
    font-weight: ${(props) => props.theme.typography.fontWeights.extrabold};
  }
  .coupon-free-shipping-text {
    color: ${(props) => props.theme.colorPalette.green[500]};
    font-weight: ${(props) => props.theme.typography.fontWeights.bold};
  }
  .progress-bar-wrapper {
    border-radius: ${(props) => props.theme.spacing.ELEM_SPACING.XS_1};
    overflow: hidden;
    background-color: rgba(0, 93, 149, 0.1);
    height: ${(props) => props.theme.spacing.ELEM_SPACING.REG};
    margin-top: ${(props) =>
      props.fromATBDrawer
        ? props.theme.spacing.ELEM_SPACING.XS
        : props.theme.spacing.ELEM_SPACING.XS_1};
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
    }
  }
  .quick-add-button-wrapper {
    display: flex;
    justify-content: space-between;
    margin-top: 18px;
    align-items: center;
  }
  .quick-add-text {
    color: ${(props) => props.theme.colorPalette.gray[900]};
    font-family: Nunito;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%;
    @media ${(props) => props.theme.mediaQuery.medium} {
      font-size: 14px;
    }
  }
  .quick-add-button {
    display: flex;
    width: 118px;
    padding: 6px 10px 4px;
    justify-content: center;
    align-items: center;
    gap: 6px;
    border-radius: 6px;
    border: 1px solid ${(props) => props.theme.colorPalette.gray[600]};
    background: ${(props) => props.theme.colors.WHITE};
    cursor: pointer;
  }
  .quick-add-button-plus {
    font-size: 16px;
    color: ${(props) => props.theme.colorPalette.gray[600]};
    font-weight: 800;
    line-height: 16px;
  }
  .quick-add-button-text {
    color: ${(props) => props.theme.colorPalette.gray[900]};
    text-align: center;
    font-family: Nunito;
    font-size: 11px;
    font-style: normal;
    font-weight: 800;
    line-height: 16px;
    text-transform: uppercase;
  }
  .progress-wrapper {
    height: 100%;
    width: ${(props) =>
      props.isFreeShippingCouponApplied ? '100' : props.shippingFreePercentage}%;
    background-image: repeating-linear-gradient(
      -48deg,
      #005d95 0px,
      #005d95 29px,
      rgba(0, 93, 149, 0.6) 29px,
      rgba(0, 93, 149, 0.6) 56px
    );
    transition: width 0.3s ease-in-out;
  }
`;

export default styles;
